import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {TagsService} from '../../services';
import {Observable, of} from 'rxjs';
import {FormControl} from '@angular/forms';
import {MatAutocompleteTrigger} from '@angular/material';
import {map, startWith} from 'rxjs/operators';
import find from 'lodash/find';
import {ToasterService} from 'angular2-toaster';


@Component({
  selector: 'app-tags',
  templateUrl: './app-tags.component.html',
  styleUrls: ['./app-tags.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class AppTagsComponent implements OnInit {

  // Tags suggestion management
  public allTags = [];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  public inputHasFocus = false;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  @ViewChild('textInput') textInput: ElementRef;
  @Input() tags: Array<{ id?: number, name: string }> = [];
  @Input() entity_id: number;
  @Input() type: string;
  @Input() isFilter: boolean;
  @Input() results: any[] = null;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() onTagClick?: EventEmitter<object> = new EventEmitter<object>();
  @Output() onTagRemove?: EventEmitter<object> = new EventEmitter<object>();
  @Input() inFilterSection: boolean;
  @Input() placeholder: string = 'Insert tags here';

  @Input() overrideClass: string = '';

  @Input() deleteTagService!: (args?) => Promise<any>;
  @Input() createTagService!: (args?) => Promise<any>;

  constructor(
    private tagsService: TagsService,
    private toasterService: ToasterService) {
  }

  ngOnInit() {
    // Filter tags suggestion
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  public updateAutoComplete() {
    let obs: Observable<any> = this.tagsService.getTags();

    if (this.results && Array.isArray(this.results)) {
      obs = of(this.results);
    }

    // Get Tags
    obs
      .subscribe(
        allTags => {
          this.allTags = allTags;

          // remove existing tags from autocomplete
          for (const tag of this.tags) {
            const tagToFind = find(this.allTags, {'id': tag['id']});
            if (tagToFind !== undefined) {
              this.allTags.splice(this.allTags.indexOf(tagToFind), 1);
            }
          }

          this.myControl.setValue(this.textInput.nativeElement.value);
          this.autocomplete.updatePosition();
          if (this.inputHasFocus) {
            this.autocomplete.openPanel();
          }
        });
  }

  // Filter function for tags suggestion
  private _filter(value: string): string[] {
    if (typeof value === 'string' && this.allTags) {
      const filterValue = value.toLowerCase();
      return this.allTags.filter(option => option.name.toLowerCase().includes(filterValue));
    }
  }

  addTagFromInput($event: Object) {
    this.inputHasFocus = false;
    const inputVal = $event['target'].value;

    // Check if value is not empty and comes from 'blur' or 'Enter keypress' events
    if (inputVal.replace(/\s/g, '').length && ($event['key'] === 'Enter' || $event['type'] === 'blur')) {
      const keyAlreadyExisting = find(this.tags, {'name': inputVal}) !== undefined;
      if (!keyAlreadyExisting && !this.isFilter) {
        // call API
        const tagToAdd = {'name': inputVal};
        this.tags.push(tagToAdd);
        if (!this.isFilter) {
          this.addTag([tagToAdd]);
        }

        // reset input and close autocomplete
        $event['target'].value = '';
        this.myControl.reset();
        this.autocomplete.closePanel();
      }
    }
  }

  onTagSelect(optionObj: Object) {

    const optionName = optionObj['option'].viewValue;
    const optionId = optionObj['option'].value;
    const keyAlreadyExisting = find(this.tags, {'id': optionId}) !== undefined;

    if (!keyAlreadyExisting) {
      const tagToAdd = {'id': optionId, 'name': optionName};
      this.tags.push(tagToAdd);
      if (!this.isFilter) {
        this.addTag([tagToAdd]);
      }

      tagToAdd['action'] = 'add';
      this.notify.emit(tagToAdd);

      // reset text input
      this.textInput.nativeElement.value = '';
    } else {
      this.myControl.setValue(optionName);
      this.textInput.nativeElement.value = optionName;
    }

  }

  async addTag(tagsToAdd: Array<Object>) {
    let addedTags;
    // Add Tag
    try {
      if (this.createTagService) {
        addedTags = await this.createTagService(tagsToAdd[0]['name']);
      } else {
        addedTags = await this.tagsService.saveTags(this.entity_id, tagsToAdd, this.type).toPromise();
        for (const tag of addedTags) {
          find(this.tags, {'name': tag.name}).id = tag.id;
        }
      }
      this.updateAutoComplete();
    } catch(e) {
      this.toasterService.pop('error', 'Error', 'Error saving tags. Please try again.');
    }
    // return this.tagsService.saveTags(this.entity_id, tagsToAdd, this.type)
    //   .subscribe(
    //     addedTags => {
    //       for (const tag of addedTags) {
    //         find(this.tags, {'name': tag.name}).id = tag.id;
    //       }
    //       this.updateAutoComplete();
    //     }, err => {
    //       console.log(err);
    //       this.toasterService.pop('error', 'Error', 'Error saving tags. Please try again.');
    //     });
  }

  async removeTag(tag: { id?: number, name: string }) {
    let promise = this.tagsService.deleteTags(this.entity_id, [{id: tag['id']}]);

    if (!this.isFilter) {
      try {
        if (this.deleteTagService !== null) {
          if (tag.id) {
            await this.deleteTagService(tag.id);
          }
        } else {
          await promise.toPromise();
        }
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.updateAutoComplete();
        if (this.onTagRemove) {
          this.onTagRemove.emit();
        }
      } catch(e) {
        this.toasterService.pop('error', 'Error', 'Error removing tag. Please try again.');
      }
      

      // this.tagsService.deleteTags(this.entity_id, [{id: tag['id']}])
      //   .subscribe(
      //     resp => {
      //       this.tags.splice(this.tags.indexOf(tag), 1);
      //       this.updateAutoComplete();
      //       if(this.onTagRemove)
      //         this.onTagRemove.emit();
      //     }, err => {
      //       console.log(err);
      //       this.toasterService.pop('error', 'Error', 'Error removing tag. Please try again.');
      //     });
    } else {
      this.tags.splice(this.tags.indexOf(tag), 1);
      tag['action'] = 'remove';
      this.notify.emit(tag);
      this.updateAutoComplete();
    }
  }


}
